const warpd = require('./components');
const req = require.context('./components', true, /^\.\/locale-provider\/.+_.+\.tsx$/);

warpd.locales = {};

req.keys().forEach((mod) => {
  const match = mod.match(/\/([^/]+).tsx$/);
  warpd.locales[match[1]] = req(mod).default;
});

module.exports = warpd;



// WEBPACK FOOTER //
// ./index-with-locales.js